<aside #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <div class="panel panel-default form-filtrar form-default">
        <form (ngSubmit)="onSubmit()" #filtroForm="ngForm" class="panel-body">
            <h1>Central de bloqueios:</h1>

            <div class="row">
                <div class="col-md-3 form-group">
                    <div class="filtro periodo">
                        <label>Período</label>
                        <mat-date-range-input class="periodo-campo" [formGroup]="dataPeriodo" [rangePicker]="picker">
                            <input matStartDate placeholder="00/00/0000" formControlName="inicio">
                            <input matEndDate placeholder="00/00/0000" formControlName="fim">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matIconSuffix [for]="picker">
                            <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </div>
                </div>
                <div class="col-md-3 form-group">
                    <div class="filtro">
                        <label>Status da transação</label>
                        <mat-select name="status" [(value)]="statusTransacao" class="form-control dropdown-filtro"
                            matTooltip="Status da transação">
                            <mat-option value="Todos">Todas</mat-option>
                            <mat-option value="Efetuada">Efetuadas</mat-option>
                            <mat-option value="Recusadas">Rejeitadas</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 form-group" *ngIf="usuario.retorno.tipo != tipoEntidades.frota">
                    <div class="superComboDiv">
                        <app-filtro-frota (onFrotaSelected)="selecionaFrota($event)"></app-filtro-frota>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <div class="superComboDiv">
                        <app-filtro-veiculo (onVeiculoSelected)="selecionaVeiculo($event)"></app-filtro-veiculo>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <div class="superComboDiv">
                        <app-filtro-motorista (onMotoristaSelected)="selecionaMotorista($event)"></app-filtro-motorista>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 form-group">
                    <div class="">
                        Baixar relatório em:
                        <button class="btn-export" (click)="exportTable('xlsx')"
                            title="Realiza a exportação da consulta no formato Excel."><img
                                src="assets/img/icon-export-excel.svg"></button>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="offset-md-9 col-md-3 text-center">
                    <button type="submit" class="btn btn-primary btn-submit">
                        Consultar<i class="fa fa-search"></i>
                    </button>
                </div>
            </div>

        </form>
    </div>
</aside>